import { hasCapability, type User } from "../base";

export const regionRole = {
  update: (user: User) => hasCapability(user, "regionRole.update"),
  create: (user: User) => hasCapability(user, "regionRole.create"),
  read: (user: User) => hasCapability(user, "regionRole.read"),
};
